import './ProductFilter.scss';
import Component from './ProductFilter.js';
export default Component;
